import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import { $contentLoading } from './skeleton'

const skin = era.skin('routes/library/favorites/movies')

LibraryFavoritesMoviesPage.displayName = 'LibraryFavoritesMoviesPage'
export function LibraryFavoritesMoviesPage(): JSX.Element {
  const isContentLoading = useUnit($contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className={`flex-column`}>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='libraryFavoritesMoviesGrid' />
          <ui.RenderSkin name='libraryFavoritesMoviesEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
